import { ArrowRight, ChevronDown, ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
const Index = () => {
  const [showContent, setShowContent] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowContent(true);
    }, 4500);
    return () => clearTimeout(timer);
  }, []);
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight - 80,
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen">
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-tech-grid bg-[size:50px_50px] opacity-[0.02] dark:opacity-[0.05] animate-grid-background"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <motion.div className="text-center max-w-3xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8
        }}>
            <motion.div className="mb-8" initial={{
            scale: 0.9
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.5
          }}>
              
            </motion.div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-playfair font-bold mb-8">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-tech-blue via-purple-400 to-tech-blue">
                Multifunkční 
              </span>
              <br />
              <span className="text-tech-blue">
                Svěrák
              </span>
            </h1>
            
            <div className="space-y-4 mb-8 text-xl md:text-2xl font-playfair">
              <p className="loading-text text-foreground/80">Z nápadu.</p>
              <p className="loading-text text-foreground/80">Z vrstvy po vrstvě.</p>
              <p className="loading-text text-foreground/80">Z tvojí dílny.</p>
              <p className="loading-text text-foreground/80">Multifunkční svěrák pro každého.</p>
            </div>

            {showContent && <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8
          }}>
                <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8">
                  <Link to="/about" className="btn-primary">
                    Zjistit víc <ArrowRight size={18} />
                  </Link>
                  <a href="#feature-overview" className="px-6 py-2 border border-tech-blue/50 rounded-md text-tech-blue hover:bg-tech-blue/10 transition-colors" onClick={e => {
                e.preventDefault();
                scrollToContent();
              }}>
                    Přehled
                  </a>
                </div>
              </motion.div>}
          </motion.div>
        </div>
        
        {showContent && <motion.div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 cursor-pointer" initial={{
        opacity: 0
      }} animate={{
        opacity: 1,
        y: [0, 10, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} onClick={scrollToContent}>
            <ChevronDown className="text-tech-blue" size={32} />
          </motion.div>}
      </section>
      
      {showContent && <>
          <section id="feature-overview" className="container-section">
            <div className="max-w-6xl mx-auto">
              <h2 className="section-title text-center mb-12">Převratný design svěráku</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <motion.div className="tech-card" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} viewport={{
              once: true
            }}>
                  <h3 className="text-xl font-bold mb-3">Univerzální použití</h3>
                  <p className="text-foreground/80">
                    Speciálně navržen pro širokou škálu aplikací od jemné elektroniky po robustní dílenské práce.
                  </p>
                </motion.div>
                
                <motion.div className="tech-card" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} viewport={{
              once: true
            }}>
                  <h3 className="text-xl font-bold mb-3">Inovativní materiály</h3>
                  <p className="text-foreground/80">
                    Kombinace 3D tisku a výplně z betonu zajišťuje optimální stabilitu a pevnost pro různé úkoly.
                  </p>
                </motion.div>
                
                <motion.div className="tech-card" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} viewport={{
              once: true
            }}>
                  <h3 className="text-xl font-bold mb-3">Vyměnitelné čelisti</h3>
                  <p className="text-foreground/80">
                    Různé typy čelistí umožňují přizpůsobení svěráku konkrétním potřebám a projektům.
                  </p>
                </motion.div>
              </div>
              
              <div className="mt-12 text-center">
                <Link to="/technical-details" className="btn-primary inline-flex">
                  Technické detaily <ArrowRight size={18} />
                </Link>
              </div>
            </div>
          </section>

          <section className="container-section bg-background/50 backdrop-blur-sm">
            <div className="max-w-6xl mx-auto">
              <h2 className="section-title text-center mb-12">Svěrák v praxi</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <motion.div className="tech-card overflow-hidden" initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6
            }} viewport={{
              once: true
            }}>
                  <div className="relative aspect-video rounded-lg overflow-hidden mb-6">
                    <img src="/lovable-uploads/87c30f91-b8ab-42d7-b014-80755edff6bd.png" alt="Multifunkční svěrák NFC" className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
                      <div className="absolute bottom-4 left-4 text-white font-playfair">
                        <h3 className="text-lg font-semibold">Svěrák NFC</h3>
                        <p className="text-sm opacity-90">Precizní upnutí pro každý projekt</p>
                      </div>
                    </div>
                  </div>
                </motion.div>
                
                <motion.div className="tech-card flex flex-col items-center p-8" initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} viewport={{
              once: true
            }}>
                  <h3 className="text-2xl font-playfair font-bold mb-6 text-tech-blue">Sledujte nás online</h3>
                  
                  <div className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl shadow-xl mb-6 hover:shadow-2xl transition-shadow duration-300">
                    <img src="/lovable-uploads/19e3d2fd-6b42-4ec6-9593-4b0dd099a577.png" alt="QR kód s odkazy na sociální sítě" className="w-48 h-48 object-contain" />
                  </div>
                  
                  <p className="text-foreground/80 mb-6 text-center font-playfair">
                    Naskenujte QR kód pro přístup k našim sociálním sítím a dalším odkazům
                  </p>
                  
                  <a href="https://linktr.ee/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-tech-blue hover:text-purple-400 transition-colors duration-300">
                    Navštívit Linktree <ExternalLink size={16} />
                  </a>
                </motion.div>
              </div>
            </div>
          </section>
        </>}
    </div>;
};
export default Index;